// This file is automatically generated. Any manual changes will be lost.
// Latest updates: https://github.com/workivate/wa-storybook/pulls?q=is%3Apr+is%3Aclosed+%5BAutomated%5D+Merge+Google+Analytics+updates+in+to+develop

export const ScreensToSectionMap = {
  '/assessments/:assessment_id/details': 'wellbeing',
  '/unsupported': 'other',
  '/chat': 'life',
  '/global-chat': 'life',
  '/child-care': 'wellbeing',
  '/confidential-support-request': 'life',
  '/confidential-support-request/complete': 'wellbeing',
  '/counsellor-locator': 'life',
  '/counsellor-locator/search': 'life',
  '/general-enquiry': 'wellbeing',
  '/get-help-now': 'life',
  '/health-coaching': 'wellbeing',
  '/health-coaching/details': 'wellbeing',
  '/health-coaching/submitted': 'wellbeing',
  '/lactcorp': 'other',
  '/legal-services': 'wellbeing',
  '/life/:contentSection/articles/*': 'life',
  '/life/:contentSection/categories/*': 'life',
  '/life/:contentSection/categories/*/listing': 'wellbeing',
  '/life/:contentSection/error': 'wellbeing',
  '/life/:contentSection/search': 'life',
  '/life/employee-assistance': 'life',
  '/life/employee-assistance/categories': 'life',
  '/life/employee-assistance/international-numbers': 'life',
  '/life/employee-assistance/quicklink-detail/:quicklink_id': 'life',
  '/life/employee-assistance/search/filter': 'life',
  '/life/hwr': 'life',
  '/life/modalities': 'life',
  '/limited-account': 'profile',
  '/limited-account/confirmation': 'profile',
  '/limited-account/create': 'profile',
  '/need-help': 'wellbeing',
  '/wellness-tools': 'wellbeing',
  '/dependant-accounts': 'other',
  '/dependant-accounts/confirmation': 'other',
  '/dependant-accounts/info': 'other',
  '/dependant-accounts/invite': 'other',
  '/fullscreen-audio': 'other',
  '/fullscreen-video': 'other',
  '/gallery': 'other',
  '/getlifeworksinchina': 'other',
  '/intro': 'other',
  '/pictureInPicture-video': 'other',
  '/checkout/confirmation': 'perks',
  '/checkout/payment': 'perks',
  '/cinemas': 'perks',
  '/cinemas/:id': 'perks',
  '/cinemas/:id/terms': 'perks',
  '/cinemas/codes': 'perks',
  '/cinemas/error': 'perks',
  '/cinemas/info': 'perks',
  '/cinemas/stores': 'perks',
  '/gift-cards': 'perks',
  '/gift-cards/:id': 'perks',
  '/gift-cards/:id/about': 'perks',
  '/gift-cards/:id/terms': 'perks',
  '/gift-cards/categories': 'perks',
  '/gift-cards/categories/search': 'perks',
  '/gift-cards/category/:categoryId': 'perks',
  '/gift-cards/codes': 'perks',
  '/gift-cards/error': 'perks',
  '/gift-cards/popular': 'perks',
  '/gift-cards/search': 'perks',
  '/offers/colleague': 'perks',
  '/offers/colleague/:offer_id': 'perks',
  '/offers/colleague/:offer_id/terms': 'perks',
  '/offers/colleague/search': 'perks',
  '/offers/in-store': 'perks',
  '/offers/in-store/:offer_id': 'perks',
  '/offers/in-store/:offer_id/terms': 'perks',
  '/offers/in-store/search': 'perks',
  '/perks-home-page': 'perks',
  '/perks/categories': 'perks',
  '/restaurants': 'perks',
  '/restaurants/:id': 'perks',
  '/restaurants/:id/terms': 'perks',
  '/restaurants/codes': 'perks',
  '/restaurants/gift-cards': 'perks',
  '/restaurants/gift-cards/search': 'perks',
  '/restaurants/gift-cards/categories': 'perks',
  '/restaurants/gift-cards/categories/search': 'perks',
  '/retailer-redirect': 'perks',
  '/shop': 'perks',
  '/shop/categories': 'perks',
  '/shop/retailers/:benefit_id': 'perks',
  '/shop/retailers/category/:category_id': 'perks',
  '/shop/offers/category/:category_id': 'perks',
  '/shop/search': 'perks',
  '/svm-giftcards/:giftcard_id?reload&value': 'perks',
  '/wallet': 'perks',
  '/wallet/info': 'perks',
  '/wallet/summary': '',
  '/wallet/transactions': 'perks',
  '/wallet/transactions/:id/detail': 'perks',
  '/wallet/transactions/plainstate': 'perks',
  '/wallet/transactions/declined': 'perks',
  '/wallet/transactions/query': '',
  '/wallet/transactions/query-confirmation': '',
  '/wallet/withdraw': '',
  '/wallet/withdraw/confirmation': '',
  '/wallet/transactions/:id/query': 'perks',
  '/wallet/withdraws': 'perks',
  '/wallet/withdraw/bank-form': 'perks',
  '/wallet/withdraw/paypal-form': 'perks',
  '/wallet/withdraw/bank-confirmation': 'perks',
  '/wallet/withdraw/paypal-confirmation': 'perks',
  '/spot-rewards': 'perks',
  '/spot-rewards/codes': 'perks',
  '/spot-rewards/gift-cards': 'perks',
  '/spot-rewards/gift-cards/:id': 'perks',
  '/spot-rewards/gift-cards/search': 'perks',
  '/spot-rewards/gift-cards/categories': 'perks',
  '/spot-rewards/gift-cards/categories/search': 'perks',
  '/spot-rewards/gift-cards/:id/terms': 'perks',
  '/spot-rewards/info': 'perks',
  '/auth-state-info': 'prelogin',
  '/confirm-email': 'prelogin',
  '/forgotten-password': 'prelogin',
  '/landing': 'prelogin',
  '/login': 'prelogin',
  '/login/sso': 'prelogin',
  '/login/sso-notice': 'prelogin',
  '/login/mfa-verification': 'prelogin',
  '/mfa-setup': 'prelogin',
  '/mfa-setup/download-auth-app': 'prelogin',
  '/mfa-setup/landing': 'prelogin',
  '/mfa-setup/qr-code': 'prelogin',
  '/mfa-setup/success': 'prelogin',
  '/mfa-setup/activation-code': 'prelogin',
  '/reset-password/:c': 'prelogin',
  '/signup': 'prelogin',
  '/signup/invitation': 'prelogin',
  '/signup/invitation/resend-invitation': 'prelogin',
  '/signup/invitation/resend-invitation-success': 'prelogin',
  '/claims-data': 'profile',
  '/notifications': 'profile',
  '/profile/:userId': 'profile',
  '/profile/:userId/achievements': 'profile',
  '/profile/:userId/achievements/detail': 'profile',
  '/profile/:userId/user-recognitions': 'profile',
  '/profile/edit': 'profile',
  '/settings': 'profile',
  '/settings/change-password': 'profile',
  '/settings/claims-data': 'profile',
  '/settings/email-notifications': 'profile',
  '/settings/payment-methods': 'profile',
  '/settings/push-notifications': 'profile',
  '/terms-of-use': 'profile',
  '/terms': 'profile',
  '/user-not-found': 'other',
  '/directory': 'social',
  '/directory/search': 'social',
  '/feed': 'social',
  '/feed/:id': 'social',
  '/feed/:id/participants': 'social',
  '/feed/filter': 'social',
  '/feed/group/:groupId': 'social',
  '/feed/group/:groupId/about': 'social',
  '/feed/search': 'social',
  '/feed/post/mark_as_read': 'social',
  '/groups': 'social',
  '/groups/search': 'social',
  '/leaderboard': 'social',
  '/new-post/compose': 'social',
  '/new-recognition/badge': 'social',
  '/new-recognition/badge_preview': 'social',
  '/new-recognition/colleague': 'social',
  '/new-recognition/compose': 'social',
  '/assessments': 'wellbeing',
  '/assessments/:assessment_id': 'wellbeing',
  '/assessments/:assessment_id/details/:archive_id': 'wellbeing',
  '/assessments/:assessment_id/results': 'wellbeing',
  '/assessments/:assessment_id/results/bmi-info': 'wellbeing',
  '/assessments/:assessment_id/results/gender': 'wellbeing',
  '/assessments/:assessment_id/results/regression-reminder': 'wellbeing',
  '/assessments/:type_id/completed': 'wellbeing',
  '/assessments/:type_id/to-complete': 'wellbeing',
  '/assessments/earning-points': 'wellbeing',
  '/assessments/in-progress': 'wellbeing',
  '/assessments/not-started': 'wellbeing',
  '/assessments/total-thi-results': 'wellbeing',
  '/challenges': 'wellbeing',
  '/challenges/not-started': 'wellbeing',
  '/challenges/in-progress': 'wellbeing',
  '/challenges/completed': 'wellbeing',
  '/challenges/:challengeId/:settings': 'wellbeing',
  '/challenges/:challengeId/settings': 'wellbeing',
  '/challenges/:challengeId/create-team': 'wellbeing',
  '/challenges/:challengeId/:teamId': 'wellbeing',
  '/challenges/:challengeId/select-habits': 'wellbeing',
  '/challenges/:challengeId/joined-confirmation': 'wellbeing',
  '/challenges/:participationType/:challengeId': 'wellbeing',
  '/challenges/:participationType/:challengeId/activity': 'wellbeing',
  '/challenges/habit/:challengeId/activity': 'wellbeing',
  '/challenges/habit/:habitId/select-habits': 'wellbeing',
  '/challenges/:challengeId/:habitId/update-habit': 'wellbeing',
  '/offers/tiering-rewards': 'wellbeing',
  '/offers/tiering-rewards/:offerId': 'wellbeing',
  '/programs': 'wellbeing',
  '/programs/:programId': 'wellbeing',
  '/programs/:programId/connect': 'wellbeing',
  '/programs/:programId/join': 'wellbeing',
  '/programs/:programId/modules/:moduleId': 'wellbeing',
  '/programs/:programId/modules/:moduleId/completed': 'wellbeing',
  '/programs/:programId/overview/:moduleOverviewId': 'wellbeing',
  '/programs/:programId/settings': 'wellbeing',
  '/programs/info': 'wellbeing',
  '/programs/join': 'wellbeing',
  '/tiering': 'wellbeing',
  '/tiering/activity': 'wellbeing',
  '/tiering/regression': 'wellbeing',
  '/wellbeing': 'wellbeing',
  '/wellbeing/info': 'wellbeing',
  '/wellbeing/recommendations': 'wellbeing',
  '/wellness/categories': 'wellbeing',
  '/wellness/categories/subcategories': 'wellbeing',
  '/wellness/categories/subcategories/summary': 'wellbeing',
  '/wellness/series-reflection': 'wellbeing',
  '/wellness/session': 'wellbeing',
  '/wellness/session/feedback': 'wellbeing',
  '/wellness/upsell': 'wellbeing',
  '/pension-and-benefits': 'integrations',
  '/pension-and-benefits/portal': 'integrations',
  '/zendesk': 'other',
  '/more': 'other',
  '/app-update': 'other',
  '/404': 'other',
  '/sso-redirect': 'prelogin',
  '/view-email-browser': 'other',
  '/profile/:userId?': 'profile',
  '/tiering/custom-activity/:activityId': 'wellbeing',
  '/checkout/:step': 'perks',
  '/spot-rewards/gift-cards/popular': 'perks',
  '/spot-rewards/gift-cards/category/:categoryId': 'perks',
  '/spot-rewards/gift-cards/error': 'perks',
  '/redirecting': 'other',
  '/': 'other',
  '/appointments/view-appointments/:id/cancel': 'appointments',
  '/appointments/view-appointments/:id': 'appointments',
  '/appointments/view-appointments': 'appointments',
  '/appointments/appointment-confirmation': 'appointments',
  '/appointments/appointment-type': 'appointments',
  '/appointments/contact-details': 'appointments',
  '/appointments/counsellor-profile/:id': 'appointments',
  '/appointments/counsellor-profile/:id/change': 'appointments',
  '/appointments/counsellor-profile/:id/change-counsellor': 'appointments',
  '/appointments/counsellor-selection': 'appointments',
  '/appointments/timeslot-selection': 'appointments',
  '/appointments/user-location': 'appointments',
  '/appointments/your-counsellor': 'appointments',
  '/appointments/payment-details': 'appointments',
  '/appointments/payment-disclaimer': 'appointments',
  '/consent/pop-up': 'consent',
  '/return-to-teams': 'other',
  '/my-care': 'mycare',
  '/my-care/other-services': 'mycare',
  '/my-care/assessments': 'mycare',
  '/my-care/assessments/history': 'mycare',
  '/care-issues/how-to-work': 'careplan',
  '/care-issues/counselling-intro': 'careplan',
  '/care-issues/select': 'careplan',
  '/care-issues/not-sure': 'careplan',
  '/care-issues/something-else': 'careplan',
  '/care-issues/confirmation': 'careplan',
  '/care-assessments': 'assessments',
  '/care-assessments/under-age': 'assessments',
  '/care-assessments/sensitive-content': 'assessments',
  '/care-assessments/immediate-help': 'assessments',
  '/care-assessments/contact-info': 'assessments',
  '/care-assessments/contact-us': 'assessments',
  '/care-assessments/contact-number': 'assessments',
  '/care-assessments/contact-confirmation': 'assessments',
  '/care-assessments/assessment-intro': 'assessments',
  '/care-assessments/care-plan-ready': 'assessments',
  '/care-assessments/assessment-scores': 'assessments',
  '/care-assessments/whats-next': 'assessments',
  '/care-assessments/retake': 'assessments',
  '/care-assessments/retake/assessment-intro': 'assessments',
  '/care-assessments/retake/welcome': 'assessments',
  '/care-assessments/counselling-next-steps': 'assessments',
  '/care-plan/overview': 'careplan',
  '/care-plan/activity:id?': 'careplan',
  '/care-plan/change-plan': 'careplan',
  '/care-plan/complete-plan': 'careplan',
  '/care-plan/intro': 'careplan',
  '/care-plan/next-steps': 'careplan',
  '/mood-tracking/new-entry': 'mood',
  '/mood-tracking/edit-entry': 'mood',
  '/mood-tracking/history': 'mood',
  '/mood-tracking/custom-factors': 'mood',
  '/journal/new-entry': 'journal',
  '/journal/edit-entry': 'journal',
  '/journal/view-entry': 'journal',
  '/journal/history': 'journal',
  '/home': 'home',
  '/home/services': 'home',
  'interests/categories': 'onboarding',
  'interests/setfocus': 'onboarding',
  'interests/recommendations': 'onboarding',
};
